import React from "react";
import { AdminCarbonRemovalProjectType } from "@ecologi/shared";
import { ProjectVisualsType } from "./project-visuals";
import RemovalIcon from "@ecologi/assets/icons/ProjectInsights/removal.svg";

const PATH = "/images/app/forest/carbon_removal/pictograms/";

export const carbonRemovalVisuals: Record<
  AdminCarbonRemovalProjectType,
  ProjectVisualsType
> = {
  AFFORESTATION_REFORESTATION_AND_REVEGETATION: {
    icon: <RemovalIcon />,
    pictogram: `${PATH}arr.svg`,
  },
  BLUE_CARBON: {
    icon: <RemovalIcon />,
    pictogram: `${PATH}blue-carbon.svg`,
  },
  BIOCHAR: {
    icon: <RemovalIcon />,
    pictogram: `${PATH}biochar.svg`,
  },
  DIRECT_AIR_CAPTURE: {
    icon: <RemovalIcon />,
    pictogram: `${PATH}default.svg`,
  },
  ENHANCED_ROCK_WEATHERING: {
    icon: <RemovalIcon />,
    pictogram: `${PATH}erw.svg`,
  },
  REGENERATIVE_AGRICULTURE: {
    icon: <RemovalIcon />,
    pictogram: `${PATH}regenerative-agriculture.svg`,
  },
};
